export const endpoints = {
  ORGANIZATION_PROBLEMS_VIEW: "/organization/trouble/view",
  ORGANIZATION_PROBLEM_COMPLETE: "/organization/trouble/completed",
  ORGANIZATION_PROBLEM_REJECT: "/organization/trouble/rejected",
  ORGANIZATION_PROBLEM_ATTACH: "/organization/trouble/attach",
  ORGANIZATION_PROBLEM_DELETE: "/organization/trouble/delete",
  ORGANIZATION_PROBLEM_SEND_MESSAGE: "/organization/trouble/chat/create",
  ORGANIZATION_EMPLOYEES_SELECT: "/organization/admin/select",
  ORGANIZATION_SUBSIDIARY_SELECT: "/organization/subsidiary/select",
}